module.exports = __webpack_public_path__ + "bd.no1.3dfef8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bd.no1.jpg
// module id = 958U
// module chunks = 0